import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import './login.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { resetMiscData, setAgentInfo, setClientRole, setDeviceInfo, setLoginTimestamp, setLogoutEnabled, setRequesterId, setToken } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: '',
			emailId: '',
			password: '',
			message: ''
		}
	}


	componentDidMount() {
		store.dispatch(setAgentInfo(''));
		store.dispatch(resetMiscData);
	}
	componentWillUnmount() {
	}

	checkValidation() {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailId)) {
			return (true)
		}
		alert("You have entered an invalid email address!")
		return (false)
	}





	enterUserId = (e) => {
		e.preventDefault();
		this.setState({
			userId: e.target.value,
			userIdErrMsg: ''
		})
	}
	enterPassword = (e) => {
		e.preventDefault();
		this.setState({
			password: e.target.value,
			passwordErrMsg: ''
		})
	}

	loginWithPassword = (event) => {
		event.preventDefault();
		this.setState({
			userIdErrMsg: '',
			passwordErrMsg: ''
		})

		if (this.state.userId != '' && this.state.password != '') {

			var user = {
				id: this.state.userId,
				role: "RETAILER"
			}

			var credentials = {
				user: user,
				pass: this.state.password
			}

			const requestHeader = {
				msgType: "LOGIN",
				service: 'ADMIN_WEB',
				src: "login",
				dst: "dashboard",
				channel: "ADMIN",

				requestId: uuidv4(),//filled by the 3rd party requester
				time: moment().utc(),
				traceId: uuidv4(),
			}

			var authorizeRequest = "";


			authorizeRequest = {
				header: requestHeader,
				credentials: credentials

			}

			console.log('request::' + JSON.stringify(authorizeRequest));

			var url = '/api/v1/retailer/login';
			httpClient.post(url, authorizeRequest
			).then((response) => {


				if (response.data.response.msg == 'SUCCESS') {

					console.log('login time:', moment().format("DD-MM-YYYY hh:mm:ss"));


					var token = response.data.token;

					store.dispatch(setAgentInfo(this.state.userId));
					store.dispatch(setToken(token));
					store.dispatch(setClientRole("ROLE_RETAILER"))
					store.dispatch(setRequesterId("W9853028034FPAY"));
					store.dispatch(setLogoutEnabled("true"));
					store.dispatch(setLoginTimestamp(new Date()));

					setTimeout(() => {
						var goTodashboard = document.getElementById('goTodashboard');
						goTodashboard.click();

					}, 700);



				} else {
					var goTo403 = document.getElementById('goTo403');
					goTo403.click();
				}
			}).catch(error => {
				// if (error.message.includes("401")) {
				// 	tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				// } else {

				// }
				console.log(error.message);
			});
		} else {
			if (this.state.userId == '') {
				this.setState({
					userIdErrMsg: 'Please enter user Id',
				})
			}
			if (this.state.password == '') {
				this.setState({
					passwordErrMsg: 'Please enter password',
				})

			}
		}



	}
	render() {

		return (
			<div>
				<div class="login-container">
					<Link to='/dashboard'>
						<button id="goTodashboard"
							hidden={true}></button>
					</Link>
					<Link to='/403'>
						<button id="goTo403"
							hidden={true}></button>
					</Link>
					<div class="container-fluid">
						<div class="row justify-content-center">
							<div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
								<div class="login-box">
									<div class="login-head">
										<Link to='/dashboard'>
											<button id='routeToDashBoard' hidden={true}></button>
										</Link>

										<img src="images/finxpay.png" alt="finXpay" class="inxpay" />
										<h3>Corporate Bill Payment System!</h3>
										<p>Login to continue</p>
									</div>

									<div class="login-form">
										<form onSubmit={this.loginWithPassword}>
											<div class="form-floating">
												<input type="text" class="form-control" id="emailid" placeholder="Retailer ID"
													onChange={this.enterUserId} required />
												<label for="emailid">Retailer ID</label>
											</div>
											<div class="form-floating">
												<input type="password" class="form-control" id="pass" placeholder="Password"
													onChange={this.enterPassword} required />
												<label for="pass">Password</label>
											</div>
											<div class="md-form">
												{/* <img src="images/captcha.jpg" alt="captcha" class="img-fluid"/> */}

											</div>
											<button class="btn" type="submit">Login Now</button>
										</form>

										{/* <p><a href="#">Forgot password?</a></p> */}
									</div>
								</div>
							</div>

							<div class="col-12">
								<div class="logcopy">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solution Pvt Ltd</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { phone } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(Login);
